import { NOOP_INSTRUMENTATION_CONFIG } from '#pplx/frontend/framework/instrumentation/types.js';
import { createContext } from 'react';
const NOOP_TRANSPORT_CONTEXT_VALUE = {
    config: NOOP_INSTRUMENTATION_CONFIG,
    configure: () => { },
};
/**
 * Holds the active transport config and a setter for runtime mutation. Defaults
 * to a no-op pair so consumers never need to branch on null. Registered globally
 * so HMR / multiple module loads can't produce duplicate context instances.
 */
export const TransportContext = createContext(NOOP_TRANSPORT_CONTEXT_VALUE);
TransportContext.displayName = 'InstrumentationTransportContext';
//# sourceMappingURL=TransportContext.js.map